// Email tab summary bar. Today's-only counts.
// Pure presentational — Email.tsx does the data fetching.

import { JarvisCard } from '@/components/JarvisCard'
import type { TimeSavingsAggregate } from '@/types'

interface Props {
  totals: TimeSavingsAggregate | undefined
  draftsReady: number
  flaggedCount: number
}

function hoursLabel(totalMinutes: number): string {
  if (totalMinutes >= 60) return `${(totalMinutes / 60).toFixed(1)} hrs`
  return `${totalMinutes} min`
}

export function EmailSummaryBar({ totals, draftsReady, flaggedCount }: Props) {
  const processed = totals?.emailsProcessed ?? 0
  const minutes = totals?.totalMinutes ?? 0

  return (
    <JarvisCard>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xs uppercase tracking-widest text-jarvis-muted">
          Today's summary
        </h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Cell label="Emails processed" value={processed} />
        <Cell label="Saved today" value={hoursLabel(minutes)} />
        <Cell label="Drafts ready" value={draftsReady} accent={draftsReady > 0} />
        <Cell label="Need your eye" value={flaggedCount} accent={flaggedCount > 0} />
      </div>
    </JarvisCard>
  )
}

function Cell({
  label,
  value,
  accent,
}: {
  label: string
  value: number | string
  accent?: boolean
}) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-jarvis-muted mb-1">{label}</div>
      <div
        className={`text-2xl font-semibold tabular tracking-tight ${
          accent ? 'text-jarvis-blue' : 'text-jarvis-text'
        }`}
      >
        {value}
      </div>
    </div>
  )
}
